<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
    <div v-if="config.name !== undefined || !id" class="mb-5">
      <v-row><h5 class="text--disabled">Input</h5></v-row>
      <v-row class="mb-3"><v-divider /></v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <v-text-field
            v-model="config.name"
            label="Input Name"
            @input="configChanged"
            :disabled="true"
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    
    <div v-if="id && !isNew && shadowDebug" class="mt-5">
      <v-row><h5 class="text--disabled">Input Details</h5></v-row>
      <v-row class="mb-3"><v-divider /></v-row>
      <v-row class="mb-3">
        <v-col cols="12">
          <pre style="inline-size: 640px; white-space: pre-wrap;">{{ input }}</pre>
        </v-col>
      </v-row>
    </div>
    
    <div v-if="id && !isNew && canEdit" class="text-right">
      <v-btn
        class="ma-1 d-none d-md-inline"
        x-small
        outlined
        @click="deleteInput()"
      >
        Delete Input
      </v-btn>
    </div>
  </v-form>
</template>
<script>
  import { mapGetters } from 'vuex'
  import ShadowMixins from '../../mixins/mixins.js'

  export default {
    name: 'GenericInput',
    
    props: ['input', 'documents', 'device_guid', 'device', 'canEdit', 'isNew'],
    
    mixins:[ShadowMixins],
    
    data() {
      return {
        valid: true,
        
        id: '',
        audio_input_detected: false,
        video_input_format: '',
        
        config: {
           
        }
      }
    },
    
    watch: {
      input() {
        this.updateValues()
      },
    },
    
    computed: {
      ...mapGetters('userPreferences', ['shadowDebug']),
      
      inputIndex() {
        for (var index in this.documents) {
          if (this.documents[index].id == this.input.id) {
            return index
          }
        }
        return -1
      },
      
      
    },
    
    mounted() {
      this.updateValues()
    },
    
    methods: {
      configChanged() {
        var validationErrors = false
        
        // check for validation errors
        if (!this.$refs.form.validate()) {
          console.log('GenericInput ' + this.device_guid + ' validation error', this.config)
          validationErrors = true
        }
        
        console.log('GenericInput ' + this.device_guid + ' configChanged', this.config)
        this.$emit('configUpdate', this.config, validationErrors)
      },
      
      updateValues() {
        if (this.input && this.input.config) {
          Object.keys(this.input).map((key) => {
            this[key] = this.input[key]
          })
          
          // htmlDecode name properties
          if (this.config.name !== undefined) {
            this.config.name = this.$helpers.htmlDecode(this.config.name)
          }
        }
        
        this.configChanged()
      },
      
      deleteInput() {
        console.log('GenericInput ' + this.device_guid + ' deleteInput')
        this.$emit('deleteInput')
      }
    }
  }
</script>